import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface AnimatedImageProps {
  src: string;
  alt: string;
  className?: string;
  delay?: number;
  loading?: "eager" | "lazy";
}

export function AnimatedImage({
  src,
  alt,
  className,
  delay = 0,
  loading = "lazy"
}: AnimatedImageProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <motion.div
      ref={ref}
      initial={{ filter: "blur(40px)", opacity: 0 }}
      animate={isInView ? { filter: "blur(0px)", opacity: 1 } : {}}
      transition={{
        duration: 0.9,
        ease: "easeOut",
        delay: delay,
      }}
      className={className}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        loading={loading}
      />
    </motion.div>
  );
}
